<h2>Entrega de premio</h2>

<form action="#" autocomplete="off" [formGroup]="deliverCodeForm">
  <div class="deliver-container">
    <span>Por favor, introduzca el Codigo de entrega:</span>
    <div class="w-75" fxLayout="row nowrap" fxLayoutGap="2rem" fxLayoutAlign="start center">
      <span fxFlex="10">Codigo:</span>
      <mat-form-field class="w-100">
        <input matInput fxflex #codeInput formControlName="code">
        <mat-error *ngIf="deliverCodeForm.get('code').hasError('maxlength') || deliverCodeForm.get('code').hasError('minlength')">
          El codigo debe ser de 4 carácteres
        </mat-error>
        <mat-error *ngIf="deliverCodeForm.get('code').hasError('required')">
          El codigo es requerido
        </mat-error>
      </mat-form-field>
    </div>
    <div class="d-flex justify-content-between align-items-center mt-3">
      <a mat-button (click)="closeDialog()">Cancelar</a>
      <a mat-raised-button color="primary" [disabled]="!deliverCodeForm.valid" (click)="submitCode()">Confirmar</a>
    </div>
  </div>
</form>